import { render, staticRenderFns } from "./FullPageLoader.vue?vue&type=template&id=05dd0d19&"
import script from "./FullPageLoader.vue?vue&type=script&lang=js&"
export * from "./FullPageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports